(function () {
  'use strict';

  var STEP_NAMES = ['size', 'photo', 'customize'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'creator_code'];
  var STORAGE_KEY = 'pnh_attribution';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;

  /* ── UTM / attribution capture ── */

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var fresh = {};
    var found = false;

    UTM_KEYS.forEach(function (key) {
      var val = params.get(key);
      if (val) {
        fresh[key] = val.substring(0, 200);
        found = true;
      }
    });

    if (found) {
      fresh._ts = Date.now();
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(fresh)); } catch (e) {}
      return fresh;
    }

    return loadAttribution();
  }

  function loadAttribution() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - (data._ts || 0) > TTL_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  var attribution = captureAttribution();

  function getAttributionParams() {
    if (!attribution) return {};
    var out = {};
    UTM_KEYS.forEach(function (key) {
      if (attribution[key]) out[key] = attribution[key];
    });
    return out;
  }

  /* ── Core event helper ── */

  function pushPnhEvent(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      brand: 'Paws & Hue',
      page_type: 'product',
      product_handle: 'pet-nigaoe-order',
      ...getAttributionParams(),
      ...(params || {})
    });
  }

  window.pushPnhEvent = pushPnhEvent;
  window.PNH_STEP_NAMES = STEP_NAMES;
  window.pnhGetAttribution = getAttributionParams;

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="lin.ee"], a[href*="line.me"]');
    if (!link) return;

    var location = link.getAttribute('data-pnh-line-location') || 'unknown';
    var text = (link.textContent || '').trim();
    if (!text) {
      var img = link.querySelector('img');
      if (img) text = (img.alt || '').trim();
    }

    pushPnhEvent('pnh_line_click', {
      location: location,
      button_text: text.substring(0, 50),
      link_url: link.href
    });
  });
})();
